export default [{
  name: 'capitaldegiro',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaEndereco: {}
      },
      Parcela: {},
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaDadosContato: {},
          PessoaBanco: {},
          PessoaEndereco: {},
          Boleto: {},
        },
        Parcela: {},
        Boleto: {},
        Boletos: [],
        BoletosSelecionados: []
      }
      commit('model', data)
    }
  },
  beforeEach ({ getters, commit }, { to, from, next }) {
    switch (to.fullPath) {
      case '/':
        if (localStorage.ambiente) { next({ path: '/partner/' + localStorage.ambiente }) }
        break;
    }
  },
  logoutFunctions: {
    afterClear (state) {
      location.href = '/partner/' + state.empresa.ambiente
    },
  }
}]
